import { Text } from 'foundations-components/components/Text';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import SegmentError from 'personalization-lib/components/targeting/SegmentError';
import Skeleton from 'personalization-lib/components/shared/display/Skeleton';
import { useGetSegmentByIdentifierQuery } from 'personalization-lib/__generated__/chirp/com/hubspot/segment/rpc/SegmentCrudRpc.hooks';
import { parseSegmentError } from 'personalization-lib/utils/error';
import { jsx as _jsx } from "react/jsx-runtime";
const SegmentName = ({
  segmentIdentifier
}) => {
  const {
    data,
    loading,
    error
  } = useGetSegmentByIdentifierQuery({
    variables: {
      identifier: segmentIdentifier
    },
    skip: !segmentIdentifier
  });
  if (error) {
    return /*#__PURE__*/_jsx(Text, {
      use: "error",
      as: "span",
      "data-test-id": "segment-error",
      children: /*#__PURE__*/_jsx(SegmentError, {
        error: parseSegmentError(error)
      })
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      blockSize: "1em",
      inlineSize: "17ch",
      as: "span"
    });
  }
  return /*#__PURE__*/_jsx(TruncateString, {
    children: data === null || data === void 0 ? void 0 : data.segment.name
  });
};
export default SegmentName;